import axios from "axios";


export const sendMail = (options) => (dispatch) => {
    try {
        return axios.post("/email", options);
    } catch (error) {
        return console.log("ERREUR SENDING MAIL ", error);
    }
};